import { isUndefined } from 'lodash/fp';
import React, { useMemo } from 'react';

import { getRiskFieldElement } from '../../documents/analytics/charts/risk-tolerance/utils';
import styles from './Table.module.scss';
import { RiskFieldValue } from '../../datasets/instances/store/types';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const RiskFieldValueCell: React.FC<{ value: any; valueFormatted: string; }> = ({ value, valueFormatted }) => {
    const riskFieldValue: RiskFieldValue = useMemo(() => JSON.parse(valueFormatted), [valueFormatted]);

    if (isUndefined(value)) {
        return null;
    }

    const { type, label, showGracePeriod, showOutput } = riskFieldValue;
    return (
        <div className={styles.fieldValueCellWrapper}>{getRiskFieldElement(riskFieldValue.value, type, label, 'table-risk-field-value-cell', showOutput, showGracePeriod)}</div>
    );
};
